import CommunityAddNotice from './CommunityAddNotice';
import CommunityCard from './CommunityCard';
import CommunityProfileHeader from './CommunityProfileHeader';
import CommunityProfilePage from './CommunityProfilePage';
import CommunityTabs from './CommunityTabs';
import CommunityAdminPage from './CommunityAdminPage';
import CommunityNoticesPage from './CommunityNoticesPage';
import CommunityMembersPage from './CommunityMembersPage';
import CommunityEditContacts from './CommunityEditContacts';
import MinimalCommunityNotice from './MinimalCommunityNotice';
import communityReducer from './community.reducer';
import communityActions from './community.actions';
import noticesReducer from './notices.reducer';
import couponsReducer from './coupons/coupons.reducer';

// the B2Me super community uuid
const B2ME_COMM_UUID = 'd3d27932-07c0-4fed-b2bc-d93fdd2f323f';
const DEV_WOODWALE_BAPTIS_COMM = '321bc575-bac3-4812-9e1d-d234192193b7';

export {
	CommunityAddNotice,
	CommunityCard,
	CommunityProfileHeader,
	CommunityProfilePage,
	CommunityTabs,
	CommunityAdminPage,
	CommunityNoticesPage,
	CommunityMembersPage,
	CommunityEditContacts,
	MinimalCommunityNotice,
	communityReducer,
	communityActions,
	noticesReducer,
	couponsReducer,
	B2ME_COMM_UUID,
	DEV_WOODWALE_BAPTIS_COMM
};



// WEBPACK FOOTER //
// ./src/community/index.js